import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, Directive } from '@angular/core';
import { GameComponentService } from './gameComponent.service';

@Component({
  selector: 'countdown',
  template: `<span class="timer {{timeExtra}}">{{timeRemain}}<span>`,
  encapsulation: ViewEncapsulation.None
})

export class CountdownComponent implements OnInit {

  @Input() seconds: number;
  intervalId;
  @Output() complete: EventEmitter<any> = new EventEmitter();
  @Output() progress: EventEmitter<any> = new EventEmitter();
  @Output() start: EventEmitter<any> = new EventEmitter();
  private timeRemain:any;
  private timeExtra:string = "";

  constructor(public _srvc: GameComponentService) {
    this.intervalId = null;
  }

  tick():void{
    if(--this.seconds < 1){
      clearInterval(this.intervalId);
      //console.log(this.seconds);
      this.timeExtra = "";
      this.complete.emit(null);

    }else{
      //console.log(this.intervalId);
    }
    //console.log(this.seconds);
    this.timeRemain = this._srvc.secondsToTime(this.seconds); // Math.floor(this.seconds/60) + ":" + ("00" +(this.seconds % 60)).toString().slice(-2);
    if (this.seconds <= 60 && this.seconds > 0) {
      // if (this.seconds % 4 == 0)
      //   this.timeExtra = "blank";
      // else
        this.timeExtra = "warning";
    }
    else {
      this.timeExtra = "";
    }

    this.progress.emit(this.seconds);
  }

  ngOnInit(){    
    this.intervalId = setInterval(() => this.tick(), 1000);
    this.timeRemain = this._srvc.secondsToTime(this.seconds); //Math.floor(this.seconds/60) + ":" + ("00" +(this.seconds % 60)).toString().slice(-2);
    this.start.emit(this.seconds);
  }
  
  ngOnDestroy(){
    clearInterval(this.intervalId);
    //this.complete.emit(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/game/countdown.component.ts